import { render, staticRenderFns } from "./Arrow.vue?vue&type=template&id=dfb1fdb4&scoped=true&"
import script from "./arrow.ts?vue&type=script&lang=ts&"
export * from "./arrow.ts?vue&type=script&lang=ts&"
import style0 from "./Arrow.vue?vue&type=style&index=0&id=dfb1fdb4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dfb1fdb4",
  null
  
)

export default component.exports